import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Modal,
  TextField,
  CircularProgress,
  useMediaQuery,
  useTheme,
  Toolbar,
  InputAdornment,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import {
  Search as SearchIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';
import axios from 'axios';

const CorporatePostRecovery = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const [postRecoveryCases, setPostRecoveryCases] = useState([]);
  const [filteredCases, setFilteredCases] = useState([]);
  const [selectedCase, setSelectedCase] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [openDetailsModal, setOpenDetailsModal] = useState(false);

  useEffect(() => {
    fetchPostRecoveryCases();
  }, []);

  const fetchPostRecoveryCases = async () => {
    try {
      const response = await axios.get('https://therapy-api.accentrixcloud.com/corporate-post-recovery');
      setPostRecoveryCases(response.data);
      setFilteredCases(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Failed to fetch post recovery cases', error);
      setLoading(false);
    }
  };

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
    setFilteredCases(
      postRecoveryCases.filter(
        (caseItem) =>
          caseItem.name.toLowerCase().includes(value) ||
          caseItem.email.toLowerCase().includes(value) ||
          caseItem.phone.toLowerCase().includes(value)
      )
    );
  };

  const handleOpenDetailsModal = (caseItem) => {
    setSelectedCase(caseItem);
    setOpenDetailsModal(true);
  };

  const handleCloseDetailsModal = () => {
    setOpenDetailsModal(false);
    setSelectedCase(null);
  };

  const renderTable = () => (
    <TableContainer component={Paper}>
      <Table size={isMobile ? 'small' : 'medium'}>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Phone</TableCell>
            <TableCell>Department</TableCell>
            <TableCell>Gender</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filteredCases.length > 0 ? (
            filteredCases.map((caseItem) => (
              <TableRow key={caseItem.id} onClick={() => handleOpenDetailsModal(caseItem)}>
                <TableCell>{caseItem.name}</TableCell>
                <TableCell>{caseItem.email}</TableCell>
                <TableCell>{caseItem.phone}</TableCell>
                <TableCell>{caseItem.department}</TableCell>
                <TableCell>{caseItem.gender}</TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={5} align="center">
                No corporate post-recovery records available.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );

  const renderDetails = () => (
    <Box>
      <IconButton onClick={handleCloseDetailsModal}>
        <ArrowBackIcon />
      </IconButton>
      <Typography variant="h6">Post-Recovery Case Details</Typography>
      <Box>
        <Typography variant="body1"><strong>Name:</strong> {selectedCase.name}</Typography>
        <Typography variant="body1"><strong>Email:</strong> {selectedCase.email}</Typography>
        <Typography variant="body1"><strong>Phone:</strong> {selectedCase.phone}</Typography>
        <Typography variant="body1"><strong>Department:</strong> {selectedCase.department}</Typography>
        <Typography variant="body1"><strong>Gender:</strong> {selectedCase.gender}</Typography>
      </Box>
    </Box>
  );

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" gutterBottom>Corporate Post-Recovery Cases</Typography>
      <Toolbar>
        <TextField
          value={searchTerm}
          onChange={handleSearch}
          placeholder="Search post-recovery cases"
          variant="outlined"
          size="small"
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Toolbar>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : selectedCase ? (
        renderDetails()
      ) : (
        renderTable()
      )}

      <Modal open={openDetailsModal} onClose={handleCloseDetailsModal}>
        <Box component={Paper} sx={{ ...modalStyle, width: isMobile ? '90%' : 400 }}>
          {renderDetails()}
        </Box>
      </Modal>
    </Container>
  );
};

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  overflowY: 'auto',
  borderRadius: 2,
};

export default CorporatePostRecovery;
